import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import AppWrap from "wrapper/AppWrap";
import { urlFor, client } from "client";
import ReactTooltip from "react-tooltip";

import "./Skills.scss";
import MotionWrap from "wrapper/MotionWrap";
import { useTranslation } from "react-i18next";
const Skills = () => {
  const { t } = useTranslation();
  const [experience, setExperience] = useState([]);
  const [skills, setSkills] = useState([]);
  useEffect(() => {
    const skillsQuery = '*[_type == "skills"]';
    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
    const exQuery = "*[_type == 'experiences']";
    client.fetch(exQuery).then((data) => {
      setExperience(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text" style={{ marginBottom: 50 }}>
        {t("section.skills")}
      </h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, j) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill.name + j}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={urlFor(skill.icon)} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="app__skills-exp">
          {experience.map((exp, index) => (
            <div key={exp.year + index}>
              <motion.div className="app__skills-exp-item">
                <div className="app__skills-exp-year">
                  <p className="bold-text">{exp.year}</p>
                </div>
                <motion.div className="app__skills-exp-works">
                  {exp.works.map((work, i) => (
                    <div key={i}>
                      <motion.div
                        whileInView={{ opacity: [0, 1] }}
                        transition={{ duration: 0.5 }}
                        className="app__skills-exp-work app__flex"
                        data-tip
                        data-for={work.name}
                      >
                        <h4 className="bold-text">{work.name}</h4>
                        <p className="p-text">{work.company}</p>
                      </motion.div>
                      <ReactTooltip
                        id={work.name}
                        effect="solid"
                        arrowColor="#fff"
                        class="skills-tooltip"
                      >
                        {work.desc}
                      </ReactTooltip>
                    </div>
                  ))}
                </motion.div>
              </motion.div>
            </div>
          ))}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
